export default "__VITE_ASSET__1cf7950c__"